export const sxStyles = {
  pageWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
};
